import { Dialog, DialogWindow } from '../../widgets/dialog';
import { NotificationBanner } from '../../widgets/notificationBanner';
import React, { FC } from 'react';
import { T } from 'src/shared/helpers';
import CheckCircleIcon from 'src/shared/material_icons/action/check_circle.svg';
import styled from 'styled-components';

const CustomDialogWindow = styled(DialogWindow)`
    flex: 1;
`;

const DialogContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    text-align: center;
    padding: 20px;
`;

const SuccessIconWrapper = styled.div`
    svg {
        width: 64px;
        height: 64px;
        color: #4caf50;
    }
`;

const Title = styled.h2`
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: ${(props) => props.theme.app.textColor};
`;

const BannersWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    text-align: left;
`;

interface PaymentSuccessDialogProps {
    salesChannelID: string;
    isShopify: boolean;
    onProceedToNextStep: () => void;
    onCancel: () => void;
}

const PaymentSuccessDialog: FC<PaymentSuccessDialogProps> = ({ salesChannelID, isShopify, onProceedToNextStep, onCancel }) => {
    return (
        <Dialog
            windowDecorator={CustomDialogWindow}
            size='small'
            title={T._('Payment Successful', 'Admin')}
            onClose={onCancel}
            buttons={[
                {
                    label: T._('Proceed to Next Step', 'Admin'),
                    onClick: onProceedToNextStep
                }
            ]}
        >
            <DialogContent>
                <SuccessIconWrapper>
                    <CheckCircleIcon />
                </SuccessIconWrapper>
                <Title>{T._('Payment Completed Successfully', 'Admin')}</Title>
                <BannersWrapper>
                    <NotificationBanner
                        type='INFO'
                        content={
                            <p>
                                {T._(
                                    'Your payment has been processed successfully. Click "Proceed to Next Step" to continue with the sales channel switch.',
                                    'Admin'
                                )}
                            </p>
                        }
                    />
                    {isShopify && (
                        <NotificationBanner
                            type='WARNING'
                            title={T._('Plan Approval Required', 'Admin')}
                            content={
                                <p>
                                    {T._(
                                        'As part of the next step, you will be redirected to Shopify to re-approve the recurring charge for your current plan. Your plan stays the same — no plan change is required.',
                                        'Admin'
                                    )}
                                </p>
                            }
                        />
                    )}
                </BannersWrapper>
            </DialogContent>
        </Dialog>
    );
};

export default PaymentSuccessDialog;
